export default {
  buttons: {
    more_payment_methods: 'Muita maksutapoja',
  },
  toasts: {
    processing: 'Käsitellään maksutietoja. Ilmoitamme, kun käsittely on valmis.',
    failed: 'Maksutietojen käsittely epäonnistui. Kokeile toista maksutapaa.',
    failed_to_load: 'Maksulomaketta ei voitu ladata. Lataa sivu uudelleen ja yritä uudelleen.',
    failed_to_save_payment_method: 'Maksutavan tallentaminen epäonnistui',
    failed_to_create_checkout_session: 'Jokin meni pieleen, yritä uudelleen',
  },
};
